module.exports = __webpack_public_path__ + "static/HazelValue4.67a3b167.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HazelValue4.jpg
// module id = 398
// module chunks = 246227742792961